import { render, staticRenderFns } from "./_.vue?vue&type=template&id=0858a152&scoped=true&"
import script from "./_.vue?vue&type=script&lang=js&"
export * from "./_.vue?vue&type=script&lang=js&"
import style0 from "./_.vue?vue&type=style&index=0&id=0858a152&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0858a152",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksContainer: require('/app/components/blocks/BlocksContainer.vue').default,UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
